/* eslint-disable */
import React, { Component } from 'react';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Footer from '../../components/Footer/';
import IntercomWidget from '../../components/IntercomWidget';
import AITutorChat from '../../components/AITutorChat';
import TagManager from 'react-gtm-module';
import { GTM_ID } from '../../common/constant';
import userStore from '../../store/userStore';
import Loader from '../../common/loader';
import { resolveExamCodeForPath } from '../../common/examUrlResolver';
import { updateSelectedExam } from '../../components/Header/service';
/* eslint-disable*/
class Full extends Component {
  constructor(props) {
    super(props);
    const pathname = props.location && props.location.pathname;
    console.log("Full pathname: ", pathname)
    this.state = {
      isChildChanged: false,
      // #292: when the opening URL belongs to a different exam than the stored selection,
      // gate rendering so child pages don't mount and fetch with the stale exam. The
      // actual switch + reload happens in componentDidMount.
      examSwitching: this.needsExamSwitch(pathname),
    };
  }

  // True when the URL maps to an exam family that differs from the currently selected one
  // and we can resolve a concrete year-code to switch to. Pure/synchronous.
  needsExamSwitch(pathname) {
    // Only reconcile for a logged-in session — updateSelectedExam needs the stored token.
    if (!localStorage.getItem('localstorageval')) {
      return false;
    }
    const currentCode = localStorage.getItem('selectedmenu');
    const targetCode = resolveExamCodeForPath(pathname, currentCode);
    // targetCode is null for same-family / no-exam paths (no switch); a `/next/` path forces
    // cfa_2027 even within the CFA1 family.
    return targetCode != null && targetCode !== currentCode;
  }

  // Reconcile the stored selection to the URL's exam, then hard-reload the same URL.
  // Mirrors the header dropdown: /updateExamSelected refreshes the Redis session + profile
  // cache asynchronously (user.js .finally emit), and the reload's round-trip gives that
  // refresh time to land before the page refetches. See spec 2026-06-24-292.
  performExamSwitch(pathname) {
    const currentCode = localStorage.getItem('selectedmenu');
    const targetCode = resolveExamCodeForPath(pathname, currentCode);
    if (!targetCode) {
      this.setState({ examSwitching: false });
      return;
    }
    localStorage.setItem('selectedmenu', targetCode);
    const data = {
      exam_selected: targetCode,
      organizationDomain: localStorage.getItem('organizationDomain'),
      role: localStorage.getItem('role'),
    };
    const reload = function () {
      window.location.reload();
    };
    try {
      updateSelectedExam(data).then(reload).catch(reload);
    } catch (e) {
      // Never strand the loader if the call throws synchronously (e.g. missing session).
      this.setState({ examSwitching: false });
    }
  }

  async componentDidMount() {
    const pathname = this.props.location && this.props.location.pathname;
    if (this.state.examSwitching) {
      // A reload is imminent; skip the profile fetch and switch the exam.
      this.performExamSwitch(pathname);
      return;
    }
    await userStore.getUserProfile();
  }

  // Catch client-side navigation to a different exam's URL (links that bypass the dropdown).
  componentWillReceiveProps(nextProps) {
    const nextPath = nextProps.location && nextProps.location.pathname;
    const currentPath = this.props.location && this.props.location.pathname;
    if (
      nextPath &&
      nextPath !== currentPath &&
      !this.state.examSwitching &&
      this.needsExamSwitch(nextPath)
    ) {
      this.setState({ examSwitching: true });
      this.performExamSwitch(nextPath);
    }
  }

  render() {
    // #292: while reconciling the exam to the opening URL, render a minimal loader so the
    // child page never mounts/fetches with the stale exam. A hard reload follows.
    if (this.state.examSwitching) {
      return (
        <div className='app'>
          <Loader />
        </div>
      );
    }
    const value = localStorage.getItem('signup') || 0;
    const tagManagerArgs = {
      gtmId: GTM_ID,
      events: {
        sendUserInfo: 'userInfo',
      },
      dataLayer: {
        page: 'Home',
        signup: value,
        currency: 'USD',
      },
    };
    TagManager.initialize(tagManagerArgs);
    localStorage.removeItem('signup');
    const { isChildChanged } = this.state;
    return (
      <div className='app'>
        <a href='#main-content' className='skip-link'>
          Skip to main content
        </a>
        <Header
          {...this.props}
          isChildChanged={isChildChanged}
          setIsChildChangedFalse={() =>
            this.setState({ isChildChanged: false })
          }
        />

        <div className='app-body'>
          <Sidebar
            {...this.props}
            isChildChanged={isChildChanged}
            setIsChildChangedFalse={() =>
              this.setState({ isChildChanged: false })
            }
            style={(outerWidth = 120 + '%')}
          />
          {/* <main className="main sidebaar-items-8-wrap"> */}
          {/* <div className="article-wrapper"> */}
          <main className='main' id='main-content' tabIndex='-1'>
            <div className='container-fluid'>
              {' '}
              {React.cloneElement(this.props.children, {
                setIsChildChangedTrue: () =>
                  this.setState({ isChildChanged: true }),
              })}
            </div>
            <IntercomWidget />
            <AITutorChat ref={(c) => { this.tutor = c; }} />
          </main>
          {/*<Aside />*/}
          <Footer exam_name={this.props.params.exam_name} {...this.props} />
          {/* </div> */}
        </div>
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js